export enum ButtonType {
  Default = 'default',
  Primary = 'primary',
  Dashed = 'dashed',
  Link = 'link'
}
